export class OrganizationEmail {

  orgUnitId!: string;
  emailAddress!: string;
  relationshipTypeCode!: string;
  relationshipTypeDescription!: string;

}
